import {Component, Inject, Injectable, NgZone,} from '@angular/core';
import {MAT_SNACK_BAR_DATA, MatSnackBar, MatSnackBarRef,} from '@angular/material/snack-bar';
import {FormGroup,} from '@angular/forms';
import {InputValidMessageVO, MessageVO,} from '@models/index';
import {SystemConstant, MessageProvider, MessageStackService,} from '@services/index';

/**
 * 共通のメッセージハンドラー
 */
@Injectable({
  providedIn: 'root',
})
export class ScreenMessageHandler {
  constructor(
    private ngZone: NgZone,
    private snackBar: MatSnackBar,
    private constant: SystemConstant,
    private messageHandler: MessageProvider
  ) {}

  /**
   * [一般開発者利用可]
   * SnackBarを閉じる。
   */
  closeMessage(
  ): void {
    this.snackBar.dismiss();
  }

  /**
   * [一般開発者利用可]
   * MessageStackからSnackBarでグローバルメッセージを表示する。
   * またMessageStackにFormGroupがセットされている場合は、その項目をエラー状態にする。
   * @param messageStack メッセージスタック(複数のメッセージを詰め込んだインスタンス)。
   * @param position top:画面上部|bottom:画面下部(デフォルト)のいずれか
   */
  showMessage(
    messageStack: MessageStackService,
    position: 'top' | 'bottom' = 'top'
  ): void {
    const messageStrings = new Array<string>();
    messageStack.messages.forEach((message: MessageVO) => {
      // メッセージVOを渡して、メッセージ文字列を取得し、画面表示用メッセージオブジェクトに追加
      const messageString = this.messageHandler.getMessageString(message, true);
      if(messageString) {
        messageStrings.push(messageString);
      }

      // メッセージVOにinputValidationErrorがある場合は当該項目にエラーを表示する
      if(message.inputValidMessage && message.inputValidMessage.length > 0) {
        message.inputValidMessage.forEach((inputValidMessage: InputValidMessageVO) => {
          const messageString =
            this.messageHandler.getMessageStringForInputValidation(inputValidMessage, false);

          // itemPathがある場合は、当該pathの項目をエラー状態にするため、itemPath(キー)を取得
          if(inputValidMessage.itemPath && inputValidMessage.itemPath.length > 0 && inputValidMessage.itemPath[0]) {
            const keys = inputValidMessage.itemPath;
            // MessageStackにセットされているすべてのフォームグループからitemPathにマッチするコントロールを取得してエラー状態にする
            messageStack.formGroups.forEach((formGroup: FormGroup) => {
              formGroup.get(keys)?.markAsDirty();
              formGroup.get(keys)?.setErrors({'serverSideInputValidation': messageString,})
            })
          }
        });
      }
    })

    // SnackBarにメッセージを表示
    this.snackBar.openFromComponent(SnackBarComponent,{
      data: {
        messages: messageStrings,
      },
      duration: this.constant.MESSAGE_DURATION[messageStack.messageLevel],
      horizontalPosition: 'center',
      verticalPosition: position,
      panelClass: 'snack-bar-' + messageStack.messageLevel,
    });
  }
}

@Component({
  selector: 'app-multi-line-snackbar',
  template: `
    <div style="display: flex; flex-direction: row; justify-content: space-between;">
      <div>
        <ul>
          <li *ngFor="let msg of data.messages">{{ msg }}</li>
        </ul>
      </div>
      <button type="button" mat-button (click)="snackBarRef.dismiss();">
        <mat-icon>close</mat-icon>
      </button>
    </div>
  `,
})
export class SnackBarComponent {
  constructor(
    public snackBarRef: MatSnackBarRef<SnackBarComponent>,
    @Inject(MAT_SNACK_BAR_DATA) public data: {messages: string[]}
  ) {}
}
